/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Closing_Scene_2Inputs */

const en_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On a break`)
};

const de_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der Pause`)
};

const zh_tw_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在休息時`)
};

const zh_cn_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在休息时`)
};

const es_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando haces una pausa`)
};

const fr_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans une pause`)
};

const it_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In pausa`)
};

const pt_br_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No intervalo`)
};

const ja_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`休憩のひとときに`)
};

const ko_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쉬는 시간에`)
};

const ru_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда на перерыве`)
};

const th_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตอนพัก`)
};

const tr_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molada`)
};

const ar_closing_scene_2 = /** @type {(inputs: Closing_Scene_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أثناء الاستراحة`)
};

/**
* | output |
* | --- |
* | "On a break" |
*
* @param {Closing_Scene_2Inputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const closing_scene_2 = /** @type {((inputs?: Closing_Scene_2Inputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closing_Scene_2Inputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_closing_scene_2(inputs)
	if (locale === "de") return de_closing_scene_2(inputs)
	if (locale === "zh_tw") return zh_tw_closing_scene_2(inputs)
	if (locale === "zh_cn") return zh_cn_closing_scene_2(inputs)
	if (locale === "es") return es_closing_scene_2(inputs)
	if (locale === "fr") return fr_closing_scene_2(inputs)
	if (locale === "it") return it_closing_scene_2(inputs)
	if (locale === "pt_br") return pt_br_closing_scene_2(inputs)
	if (locale === "ja") return ja_closing_scene_2(inputs)
	if (locale === "ko") return ko_closing_scene_2(inputs)
	if (locale === "ru") return ru_closing_scene_2(inputs)
	if (locale === "th") return th_closing_scene_2(inputs)
	if (locale === "tr") return tr_closing_scene_2(inputs)
	return ar_closing_scene_2(inputs)
});